import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./OutlineActionButton.module.css";

/**
 * Reusable outlined action button with optional leading icon.
 */
const OutlineActionButton = ({
  label,
  icon,
  onClick,
  loading = false,
  disabled = false,
  type = "button",
  ariaLabel,
}) => {
  return (
    <button
      type={type}
      className={styles.button}
      onClick={onClick}
      disabled={disabled || loading}
      aria-label={ariaLabel || label}
      aria-busy={loading}
    >
      {icon ? (
        <FontAwesomeIcon
          icon={icon}
          className={`${styles.icon} ${loading ? styles.iconSpin : ""}`}
        />
      ) : null}
      <span>{label}</span>
    </button>
  );
};

OutlineActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.object,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  ariaLabel: PropTypes.string,
};

export default OutlineActionButton;
